import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnJadwalSession = ({ startedAt, endedAt }) => {
  return (
    <Box className={styles['column__container']}>
      <TextRegular>{startedAt}</TextRegular>
      <TextRegular>{endedAt}</TextRegular>
    </Box>
  );
};

export default ColumnJadwalSession;
